import { useEffect, useRef } from "react";

export const useMouseDownOutside = (cb: () => void) => {
  const refs = [
    useRef<HTMLDivElement | null>(null),
    useRef<HTMLDivElement | null>(null),
  ] as const;

  /* oxlint-disable react-hooks/exhaustive-deps -- refs is a stable tuple of useRefs created in the same component */
  useEffect(() => {
    const act = ({ target }: MouseEvent) => {
      const node = target as Node;
      const inRefs = refs.some((ref) => ref.current?.contains(node));
      const inPopover = (target as Element).closest?.("[data-popover]");
      if (!inRefs && !inPopover) cb();
    };

    document.addEventListener("mousedown", act, true);
    return () => document.removeEventListener("mousedown", act, true);
  }, [cb, refs]);
  /* oxlint-enable react-hooks/exhaustive-deps */

  return refs;
};
